module.exports = __webpack_public_path__ + "static/media/play-circle.a81b9aef.svg";